module.exports = __webpack_public_path__ + "img/potol.f9309dc8.jpg";